module.exports = __webpack_public_path__ + "fonts/gothica1-regular-webfont.b72aae9.woff2";